import React, { useState } from 'react';
import { Box, FormControlLabel, Checkbox} from '@mui/material';
import { useTranslation } from "react-i18next";
import { LOANS_APPLICATION } from "../locales/namespaces";

export default function ErrorDashboard({ borrowerInformation, filledOut, missingFields, incorrectCompletion }) {
    const { t } = useTranslation(LOANS_APPLICATION)

    return (
        <Box mt={3} className="border-cnt" sx={{padding: '8px 28px !important', marginLeft:'36px'}} >
            <FormControlLabel
                sx={{borderBottom: '0.6px solid #DAE0F0', width:'100%', marginBottom: '3px', paddingBottom: '3px', 'label':{
                    fontSize: '12px',
                    fontWeight:'500',
                }, pointerEvents: 'none'}}
                control={
                    <Checkbox
             
                        color="primary"
                        sx={{
                            '& .icon.MuiBox-root': {
                              border: '3px solid #DAE0F0',
                              borderRadius: '8px',
                              width: '25px',
                              height: '25px',
                            },
                            '& .anticon':{
                                border: 'none !important'
                            },
                            '& .anticon svg':{
                                height: '23px',
                                width: '23px',
                                borderRadius: '8px',
                                position: 'relative',
                                fill: '#DAE0F0',
                            }
                          }}
                    />
                }
                label={t("No fields have been filled out")}
                labelPlacement="end"
            />
            <FormControlLabel
                sx={{borderBottom: '0.6px solid #DAE0F0', width:'100%', marginBottom: '3px', paddingBottom: '3px', 'label':{
                    fontSize: '12px',
                    fontWeight:'500',
                }, pointerEvents: 'none' }}
                control={
                    <Checkbox
                      
                        color="primary"
                        sx={{
                            '& .icon.MuiBox-root': {
                                border: '3px solid #485476',
                                borderRadius: '8px',
                                width: '25px',
                                height: '25px',
                            },
                            '& .anticon':{
                                border: 'none !important'
                            },
                            '& .anticon svg':{
                                height: '23px',
                                width: '23px',
                                borderRadius: '8px',
                                position: 'relative',
                                fill: '#485476',
                            }
                        }}
                    />
                }
                label={t("There are missing fields")}
                labelPlacement="end"
            />
            <FormControlLabel
                sx={{borderBottom: '0.6px solid #DAE0F0', width:'100%', marginBottom: '3px', paddingBottom: '3px', 'label':{
                    fontSize: '12px',
                    fontWeight:'500',
                }, pointerEvents: 'none'}}
                control={
                    <Checkbox
                 
                        color="primary"
                        sx={{
                            '& .icon.MuiBox-root': {
                                border: '3px solid #DBB2AF',
                                borderRadius: '8px',
                                width: '25px',
                                height: '25px',
                            },
                            '& .anticon':{
                                border: 'none !important'
                            },
                            '& .anticon svg':{
                                height: '23px',
                                width: '23px',
                                borderRadius: '8px',
                                position: 'relative',
                                fill: '#DBB2AF',
                            }
                        }}
                    />
                }
                label={t("Incorrect completion")}
                labelPlacement="end"
            />
            <FormControlLabel
                sx={{ width:'100%', 'label':{
                    fontSize: '12px',
                    fontWeight:'500',
                }, pointerEvents: 'none'}}
                control={
                    <Checkbox
            
                        color="primary"

                        sx={{
                            '& .icon.MuiBox-root': {
                                border: '3px solid #0BC1B6',
                                borderRadius: '8px',
                                width: '25px',
                                height: '25px',
                            },
                            '& .anticon':{
                                border: 'none !important'
                            },
                            '& .anticon svg':{
                                height: '23px',
                                width: '23px',
                                borderRadius: '8px',
                                position: 'relative',
                                fill: '#0BC1B6'
                            }
                        }}
                    />
                }
                label={t("Completed successfully")}
                labelPlacement="end"
            />


        </Box>
    );
}
